import Modal from '@Atom/Modal'
import Styles from './style.module.scss'
import Card from '@Atom/Card'
import ModalHeader from '@Atom/ModalHeader'
import Button from '@Atom/Button'

export default function PaymentConfirmationModal({
  type,
  onClose,
  id
}) {

  return (
    <Modal isOpen={type}>
      <Card className={Styles.container}>
        <ModalHeader title={`${type === 'positive' ? 'Terima' : 'Tolak'} Pembayaran`} />
        <p>{`Apakah Anda sudah yakin ingin ${type === 'positive' ? 'menerima' : 'menolak'} pembayaran yang dilakukan ini?`}</p>
        <div className={Styles.actions}>
          <Button
            text={'Tidak'}
            onClick={onClose}
            variant='outlined'
          />
          <Button
          text={'Ya'}
          />
        </div>
      </Card>
    </Modal>
  )
}